import { Title } from "@solidjs/meta";

export const SITE_NAME = "LYSZT";

export default function PageTitle(props) {
  return <Title>{props.title ?? props.children}</Title>;
}
